module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Sport Aluminum Gold + Antique White Open.fac3281e.png";